module.exports = __webpack_public_path__ + "img/icon_gongneng2.53dd7d17.svg";